'use strict';

const heroBannerAnimation = {
    init() {
        // const hero = document.querySelector('.js-hero-banner');
        // if (!hero) return;

        // setTimeout(() => {
        //     hero.classList.add('is-reduced');
        // }, 1500);

        // const hero = document.querySelector('.js-hero-banner');
        // if (!hero) return;

        // const iframe = hero.querySelector('iframe');
        // if (!iframe) return;

        // setTimeout(() => {
        //     iframe.style.height = '80vh'; // Adjust as needed
        //     iframe.style.transition = 'height 1s ease';
        //     hero.style.height = '80vh'; // Optional: resize the container too
        // }, 3000);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    heroBannerAnimation.init();
});
